"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6236],{

/***/ 61442:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(141817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(932165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(696649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(489554);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(491038);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(682772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(747042);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(396078);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(968309);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(209653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(319601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(833321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(369070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(438880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(749337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(447941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(241539);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(974916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(477601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(339714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(978783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(454747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(333948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(667294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(897375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(624614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(298352);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(626153);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(848189);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }


























var _excluded = ["aspectRatio", "fallbackSrc", "loading"],
  _excluded2 = ["analyticsName", "trackImpression"],
  _excluded3 = ["analyticsName"];
function cov_292sh6sq8e() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Image/Image.tsx";
  var hash = "c9a8c2c0a69bd9c54bbf29fe2d221e94190246f7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Image/Image.tsx",
    statementMap: {
      "0": {
        start: {
          line: 48,
          column: 18
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "1": {
        start: {
          line: 50,
          column: 19
        },
        end: {
          line: 50,
          column: 49
        }
      },
      "2": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 51,
          column: 70
        }
      },
      "3": {
        start: {
          line: 52,
          column: 26
        },
        end: {
          line: 52,
          column: 45
        }
      },
      "4": {
        start: {
          line: 54,
          column: 19
        },
        end: {
          line: 54,
          column: 45
        }
      },
      "5": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 59,
          column: 14
        }
      },
      "6": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 31
        }
      },
      "7": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 71,
          column: 6
        }
      },
      "8": {
        start: {
          line: 63,
          column: 23
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "9": {
        start: {
          line: 75,
          column: 26
        },
        end: {
          line: 80,
          column: 1
        }
      },
      "10": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 95
        }
      },
      "11": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 71
        }
      },
      "12": {
        start: {
          line: 170,
          column: 14
        },
        end: {
          line: 176,
          column: 2
        }
      },
      "13": {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 173,
          column: 3
        }
      },
      "14": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 100
        }
      },
      "15": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 175,
          column: 44
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 60
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 55,
            column: 14
          },
          end: {
            line: 55,
            column: 15
          }
        },
        loc: {
          start: {
            line: 55,
            column: 20
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 55
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 63,
            column: 17
          },
          end: {
            line: 63,
            column: 18
          }
        },
        loc: {
          start: {
            line: 63,
            column: 23
          },
          end: {
            line: 63,
            column: 42
          }
        },
        line: 63
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 57
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 76
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 170,
            column: 44
          },
          end: {
            line: 170,
            column: 45
          }
        },
        loc: {
          start: {
            line: 170,
            column: 82
          },
          end: {
            line: 176,
            column: 1
          }
        },
        line: 170
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 51,
            column: 47
          },
          end: {
            line: 51,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 47
          },
          end: {
            line: 51,
            column: 58
          }
        }, {
          start: {
            line: 51,
            column: 62
          },
          end: {
            line: 51,
            column: 68
          }
        }],
        line: 51
      },
      "1": {
        loc: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c9a8c2c0a69bd9c54bbf29fe2d221e94190246f7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_292sh6sq8e = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_292sh6sq8e();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







/**
 * Set of allowed aspect ratios defined by design.
 */

/**
 * NOTE ON METRIC TRACKING: Image is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down
 *  2) the entirety of the image enters the viewport
 */

var BaseImage = (cov_292sh6sq8e().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var aspectRatio = _ref.aspectRatio,
    fallbackSrc = _ref.fallbackSrc,
    loading = _ref.loading,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_292sh6sq8e().f[0]++;
  var styles = (cov_292sh6sq8e().s[1]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* .useStyleConfig */ .mq)('Image', props));
  var imgStyle = (cov_292sh6sq8e().s[2]++, _objectSpread(_objectSpread({}, styles), {}, {
    aspectRatio: (cov_292sh6sq8e().b[0][0]++, aspectRatio) || (cov_292sh6sq8e().b[0][1]++, 'auto')
  }));
  var _ref2 = (cov_292sh6sq8e().s[3]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useState)(props.src)),
    _ref3 = _slicedToArray(_ref2, 2),
    src = _ref3[0],
    setSrc = _ref3[1];
  var imgRef = (cov_292sh6sq8e().s[4]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useRef)());
  cov_292sh6sq8e().s[5]++;
  (0,react__WEBPACK_IMPORTED_MODULE_26__.useEffect)(function () {
    cov_292sh6sq8e().f[1]++;
    cov_292sh6sq8e().s[6]++;
    // Update ref src if onError fires during hydration - see bug:
    // https://github.com/facebook/react/issues/15446#issuecomment-484709466
    imgRef.current.src = src;
  }, [src]);
  cov_292sh6sq8e().s[7]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_29__/* .bricks.img */ .G.img, _extends({
    onError: function onError() {
      cov_292sh6sq8e().f[2]++;
      cov_292sh6sq8e().s[8]++;
      return setSrc(fallbackSrc);
    },
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__/* .useMergeRefs */ .qq)(imgRef, ref)
    // __css has a lower priority than sx
    ,
    __css: imgStyle,
    loading: loading
  }, props, {
    src: src
  }));
}));
var ImageWithTracking = (cov_292sh6sq8e().s[9]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref4, ref) {
  var analyticsName = _ref4.analyticsName,
    trackImpression = _ref4.trackImpression,
    props = _objectWithoutProperties(_ref4, _excluded2);
  cov_292sh6sq8e().f[3]++;
  var inViewRef = (cov_292sh6sq8e().s[10]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_31__/* .useTrackComponentInView */ .O)('imageViewEvent', trackImpression, analyticsName));
  cov_292sh6sq8e().s[11]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(BaseImage, _extends({
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__/* .useMergeRefs */ .qq)(inViewRef, ref)
  }, props));
}));

/**
 * An image view displays a single image — or in some cases, an animated
 * sequence of images — on a transparent or opaque background.
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Fallback (alternate) text to display when the image specified by the element
 * is not loaded. The `alt` attribute is officially mandatory; it's meant to
 * always be specified. If the image doesn't require a fallback (such as for an
 * image which is decorative or an advisory icon of minimal importance), you may
 * specify an empty string (""). See
 * [https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt).
 *
 * ###
 *
 * Guidelines for `alt` tags:
 *
 * 1.  For both images and icons, if it's merely decorative, you don't need to
 * write `alt` text. Pass an empty string in these cases. You only need to add
 * it for ones that provide information or function.
 *
 * 2.  Highlight key things. You don't need to go into extreme detail.
 *
 * *   What's most noticeable?
 *
 * *   Who's in it?
 *
 * *   What are they doing?
 *
 * *   Where are they?
 *
 * 3.  You don't need to actually write "Image of" or "Picture of." That should
 * get auto-included by screen readers.
 *
 * 4.  For icons that provide function, you can include action/target here, too.
 * Some examples:
 *
 * *   Chat icon = Chat with an Opendoor Expert
 *
 * *   Menu icon = Open Menu / Open Settings
 *
 * *   Search icon = Search for homes
 *
 * *   Plus icon = Add person
 *
 * 5.  See o/glossary to verify that your labels match Opendoor's guidelines for
 * copy blocks.
 *
 *
 * ###
 *
 * ✅ Pass
 *
 * <Image src={homePhotoUrl} alt="The home at 125 W Muriel Dr, Phoenix, AZ
 * 85023" />
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Image src={homePhotoUrl} />
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Image` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{imageName})
 *
 * 2.  passing `trackImpression={true}` Image impression events will only be
 * tracked the first time that the image enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_image\_view\_event for image
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Image = (cov_292sh6sq8e().s[12]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref5, ref) {
  var analyticsName = _ref5.analyticsName,
    props = _objectWithoutProperties(_ref5, _excluded3);
  cov_292sh6sq8e().f[4]++;
  cov_292sh6sq8e().s[13]++;
  if (analyticsName) {
    cov_292sh6sq8e().b[1][0]++;
    cov_292sh6sq8e().s[14]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(ImageWithTracking, _extends({
      alt: props.alt,
      analyticsName: analyticsName,
      ref: ref
    }, props));
  } else {
    cov_292sh6sq8e().b[1][1]++;
  }
  cov_292sh6sq8e().s[15]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(BaseImage, _extends({
    ref: ref
  }, props));
}));
/* harmony default export */ __webpack_exports__["Z"] = (Image);

/***/ }),

/***/ 811332:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382526);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(682772);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(319601);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(447941);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(667294);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(626153);




var _excluded = ["variant", "color"],
  _excluded2 = ["width", "height", "color"],
  _excluded3 = ["width", "height", "color"];
function cov_11d3i88gri() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Logo/Logo.tsx";
  var hash = "56f5a291cbb9ba05059d042a0c39cde6e6e60cc6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Logo/Logo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 41
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 21,
          column: 4
        }
      },
      "2": {
        start: {
          line: 25,
          column: 46
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "3": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 78,
          column: 15
        }
      },
      "4": {
        start: {
          line: 82,
          column: 43
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "5": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 92,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 41
          },
          end: {
            line: 16,
            column: 42
          }
        },
        loc: {
          start: {
            line: 16,
            column: 99
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 25,
            column: 46
          },
          end: {
            line: 25,
            column: 47
          }
        },
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 78,
            column: 15
          }
        },
        line: 31
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 82,
            column: 43
          },
          end: {
            line: 82,
            column: 44
          }
        },
        loc: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 92,
            column: 15
          }
        },
        line: 83
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 44
          },
          end: {
            line: 16,
            column: 63
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 54
          },
          end: {
            line: 16,
            column: 63
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 65
          },
          end: {
            line: 16,
            column: 82
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 73
          },
          end: {
            line: 16,
            column: 82
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 49
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 46
          }
        }],
        line: 17
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 16
          }
        }],
        line: 26
      },
      "4": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 27,
            column: 15
          }
        }],
        line: 27
      },
      "5": {
        loc: {
          start: {
            line: 82,
            column: 46
          },
          end: {
            line: 82,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 82,
            column: 54
          },
          end: {
            line: 82,
            column: 60
          }
        }],
        line: 82
      },
      "6": {
        loc: {
          start: {
            line: 82,
            column: 62
          },
          end: {
            line: 82,
            column: 75
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 82,
            column: 71
          },
          end: {
            line: 82,
            column: 75
          }
        }],
        line: 82
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0],
      "4": [0],
      "5": [0],
      "6": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "56f5a291cbb9ba05059d042a0c39cde6e6e60cc6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_11d3i88gri = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_11d3i88gri();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


/**
 * The opendoor logo has two variants:
 * 1) Primary: Logo with full name Opendoor spelled out.
 * 2) Secondary: Logo with just the O from Opendoor.
 * Opendoor logo defaults to use the primary variant if no variant is defined
 */
cov_11d3i88gri().s[0]++;
var Logo = function Logo(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? (cov_11d3i88gri().b[0][0]++, 'primary') : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? (cov_11d3i88gri().b[1][0]++, 'brand50') : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_11d3i88gri().f[0]++;
  cov_11d3i88gri().s[1]++;
  return variant === 'primary' ? (cov_11d3i88gri().b[2][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(OpendoorFullLogo, _extends({
    color: color
  }, props))) : (cov_11d3i88gri().b[2][1]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(OpendoorOLogo, _extends({
    color: color
  }, props)));
};

/** Logo with full name Opendoor spelled out. */
cov_11d3i88gri().s[2]++;
var OpendoorFullLogo = function OpendoorFullLogo(_ref2) {
  var _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? (cov_11d3i88gri().b[3][0]++, '100%') : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? (cov_11d3i88gri().b[4][0]++, '24') : _ref2$height,
    color = _ref2.color,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_11d3i88gri().f[1]++;
  cov_11d3i88gri().s[3]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_5__/* .bricks.svg */ .G.svg, _extends({
    width: width,
    height: height,
    viewBox: "0 0 186 40",
    version: "1.1"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("title", null, "Opendoor Logo"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("g", {
    "data-testid": "OpendoorFullLogo",
    id: "Homepage-1",
    transform: "translate(-624.000000, -51.000000)",
    fill: "var(--colors-".concat(color, ")")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("g", {
    id: "Header",
    transform: "translate(40.000000, 51.000000)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("g", {
    id: "Logo",
    transform: "translate(584.000000, 0.000000)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M19.6013,17.5557209 C19.6013,8.11572093 17.98775,4.20254264 13.55165,4.20254264 C9.63914,4.20254264 7.66289,6.94579845 7.66289,16.4667287 C7.66289,25.8661085 9.19553,29.7392868 13.71285,29.7392868 C17.70565,29.7392868 19.6013,27.036031 19.6013,17.5557209 M0,17.3138605 C0,6.70362791 7.29988,2.50827907 13.79376,2.50827907 C20.73063,2.50827907 27.26419,6.66362791 27.26419,16.6682791 C27.26419,27.3588217 19.96431,31.4335504 13.47043,31.4335504 C6.53387,31.4335504 0,26.996031 0,17.3138605",
    id: "Fill-1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M39.874339,29.819907 C38.502899,29.819907 37.414179,29.2146357 36.687849,28.3675039 L36.687849,13.6828527 C37.333269,13.4409922 38.341699,12.9566512 39.954939,12.9566512 C43.020219,12.9566512 44.754669,14.9737054 44.754669,20.7426977 C44.754669,28.1256434 43.060519,29.819907 39.874339,29.819907 M43.463829,9.4471938 C40.640349,9.4471938 38.382309,10.7783566 36.687849,12.2307597 L36.486349,12.2307597 L36.564159,9.8168062 C36.571289,9.59696124 36.381569,9.42176744 36.163329,9.44657364 L30.566589,10.0794419 C30.400429,10.0983566 30.275189,10.2388217 30.275189,10.4059535 L30.275189,37.172155 L30.275189,39.6174264 C30.275189,39.8130853 30.445379,39.9656434 30.640059,39.9436279 L36.396759,39.2930853 C36.562609,39.2744806 36.687849,39.1340155 36.687849,38.9668837 L36.687849,37.172155 L36.687849,33.4912248 C36.687849,32.0794419 36.647859,31.0304496 36.647859,31.0304496 C37.535079,31.2723101 38.866219,31.4335504 39.713139,31.4335504 C46.448509,31.4335504 51.368829,27.7625426 51.368829,19.3712248 C51.368829,11.9885891 47.295429,9.4471938 43.463829,9.4471938",
    id: "Fill-19"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M60.112286,17.9995349 L67.008856,17.6364341 C67.008856,12.7551938 66.364056,10.98 63.943886,10.98 C61.886726,10.98 60.273486,12.9164341 60.112286,17.9995349 M53.739926,20.3796899 C53.739926,13.360155 58.942346,9.44697674 64.266286,9.44697674 C69.767236,9.44697674 73.219396,12.1654264 73.415936,19.2776744 C73.419966,19.415969 73.307436,19.5325581 73.168556,19.5325581 L60.365556,19.5325581 C60.226676,19.5325581 60.114456,19.6491473 60.117866,19.7877519 C60.298286,26.195814 62.787586,27.964186 66.887956,27.964186 C68.889316,27.964186 70.502866,27.4990698 71.853226,26.9 C71.952736,26.8556589 72.068056,26.8817054 72.139046,26.9648062 L72.675346,27.595814 C72.756256,27.6910078 72.755326,27.8317829 72.669766,27.9223256 C71.198506,29.4742636 68.203286,31.4336434 64.266286,31.4336434 C57.248506,31.4336434 53.739926,27.2379845 53.739926,20.3796899",
    id: "Fill-5"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M89.995883,9.44700775 C87.051813,9.44700775 84.389843,10.7784806 82.252393,12.3111938 L82.090883,12.3111938 L82.170243,9.76762791 C82.176443,9.57258915 82.008423,9.41786047 81.814983,9.43956589 L76.171123,10.0795659 C76.005273,10.0981705 75.879723,10.2383256 75.879723,10.4054574 L75.879723,30.6296434 C75.879723,30.8063876 76.022943,30.9493333 76.199333,30.9493333 L81.972773,30.9493333 C82.149163,30.9493333 82.292383,30.8063876 82.292383,30.6296434 L82.292383,13.7232868 C83.179603,13.5214264 84.631643,13.1989457 86.043693,13.1989457 C87.939033,13.1989457 88.826563,13.9654574 88.826563,16.4262326 L88.826563,30.6296434 C88.826563,30.8063876 88.969783,30.9493333 89.146173,30.9493333 L94.959913,30.9493333 C95.136303,30.9493333 95.279833,30.8063876 95.279833,30.6296434 L95.279833,14.8532093 C95.279833,11.2222016 93.424483,9.44700775 89.995883,9.44700775",
    id: "Fill-11"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M112.582576,27.3589147 C111.937156,27.6010853 110.848126,28.2466667 109.194586,28.2466667 C106.129306,28.2466667 104.516066,26.1889922 104.516066,19.8553488 C104.516066,13.1986047 106.532616,11.0606202 109.436386,11.0606202 C110.929036,11.0606202 111.896856,11.9077519 112.582576,12.7548837 L112.582576,27.3589147 Z M118.995236,5.49348837 C118.995236,3.40821705 119.066226,1.49224806 119.103736,0.705891473 C119.114586,0.475813953 118.919286,0.291007752 118.690196,0.311472868 L112.881416,0.971317829 C112.712156,0.986511628 112.582576,1.12821705 112.582576,1.29844961 L112.582576,6.94589147 C112.582576,8.3979845 112.663176,9.89069767 112.663176,9.89069767 C111.816256,9.64852713 110.686926,9.44697674 109.598206,9.44697674 C103.306136,9.44697674 97.901286,12.7955039 97.901286,21.1868217 C97.901286,28.5288372 101.813486,31.4336434 105.806596,31.4336434 C108.629766,31.4336434 110.888426,30.304031 112.622876,28.8116279 L112.784076,28.8116279 L112.702236,31.0382946 C112.692936,31.2755039 112.900016,31.4631008 113.134686,31.4299225 L118.668186,30.811938 C118.855736,30.7858915 118.995236,30.6252713 118.995236,30.435814 L118.995236,5.49348837 Z",
    id: "Fill-13"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M136.791995,20.7024806 C136.791995,12.5533333 135.219365,11.0203101 132.476485,11.0203101 C129.935415,11.0203101 128.443385,12.876124 128.443385,19.8150388 C128.443385,28.0854264 129.774215,29.86 132.718285,29.86 C135.138765,29.86 136.791995,28.4482171 136.791995,20.7024806 M121.667715,20.5009302 C121.667715,12.7548837 127.152545,9.44697674 132.597695,9.44697674 C138.445845,9.44697674 143.567975,12.9567442 143.567975,20.2990698 C143.567975,28.0448062 138.163435,31.4339535 132.597695,31.4339535 C126.749545,31.4339535 121.667715,27.8832558 121.667715,20.5009302",
    id: "Fill-7"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M160.847871,20.7024806 C160.847871,12.5533333 159.275241,11.0203101 156.532361,11.0203101 C153.991291,11.0203101 152.499261,12.876124 152.499261,19.8150388 C152.499261,28.0854264 153.830401,29.86 156.774471,29.86 C159.194641,29.86 160.847871,28.4482171 160.847871,20.7024806 M145.723281,20.5009302 C145.723281,12.7548837 151.208421,9.44697674 156.653261,9.44697674 C162.501411,9.44697674 167.623541,12.9567442 167.623541,20.2990698 C167.623541,28.0448062 162.219311,31.4339535 156.653261,31.4339535 C150.805421,31.4339535 145.723281,27.8832558 145.723281,20.5009302",
    id: "Fill-9"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    d: "M182.612506,9.44700775 C180.273246,9.44700775 177.974286,11.2222016 176.724366,12.5533643 L176.562856,12.5533643 L176.641286,9.84235659 C176.648106,9.61165891 176.448776,9.42809302 176.219376,9.45382946 L170.643096,10.079876 C170.476936,10.0984806 170.351696,10.2386357 170.351696,10.4060775 L170.351696,30.5697984 C170.351696,30.7794109 170.521576,30.9493333 170.731136,30.9493333 L176.384606,30.9493333 C176.594166,30.9493333 176.764666,30.7794109 176.764666,30.5697984 L176.764666,14.2076279 C177.329176,13.6829767 178.256696,13.1583256 178.982406,13.1583256 C179.345726,13.1583256 179.587836,13.2392558 179.829636,13.6829767 C180.595956,14.9335194 181.202626,15.6563101 182.935216,15.6563101 C184.508466,15.6563101 185.914936,14.4091783 185.914936,12.4727442 C185.914936,10.4956899 184.548456,9.44700775 182.612506,9.44700775",
    id: "Fill-16"
  }))))));
};

/** Logo with just the O from Opendoor. */
cov_11d3i88gri().s[4]++;
var OpendoorOLogo = function OpendoorOLogo(_ref3) {
  var _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? (cov_11d3i88gri().b[5][0]++, '100%') : _ref3$width,
    _ref3$height = _ref3.height,
    height = _ref3$height === void 0 ? (cov_11d3i88gri().b[6][0]++, '24') : _ref3$height,
    color = _ref3.color,
    props = _objectWithoutProperties(_ref3, _excluded3);
  cov_11d3i88gri().f[2]++;
  cov_11d3i88gri().s[5]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_5__/* .bricks.svg */ .G.svg, _extends({
    width: width,
    height: height,
    viewBox: "0 0 17 24",
    fill: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("title", null, "Opendoor Logo"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("path", {
    "data-testid": "opendoorOLogo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.145 9.2703C12.145 3.45463 11.1453 1.04394 8.39652 1.04394C5.97245 1.04394 4.74795 2.73386 4.74795 8.59936C4.74795 14.3902 5.6976 16.7761 8.49644 16.7761C10.9704 16.7761 12.145 15.1108 12.145 9.2703ZM0 9.12128C0 2.58475 4.52311 0 8.54644 0C12.8446 0 16.8929 2.55998 16.8929 8.7236C16.8929 15.3097 12.3699 17.82 8.34642 17.82C4.04834 17.82 0 15.0862 0 9.12128ZM16.0108 23.0785C15.6006 22.5374 14.0208 20.453 14.0208 20.453C13.8726 20.2575 13.6186 20.1394 13.346 20.1394H3.54692C3.27434 20.1394 3.02035 20.2575 2.87212 20.453L0.882439 23.0781C0.819318 23.1614 0.785826 23.2583 0.785826 23.3574V23.7581C0.785826 23.8917 0.894706 24 1.02906 24H15.8638C15.9982 24 16.1071 23.8917 16.1071 23.7581V23.3574C16.1071 23.2583 16.0739 23.1617 16.0108 23.0785Z",
    fill: "var(--colors-".concat(color, ")")
  }));
};

/***/ })

}]);